"use strict";

exports.__esModule = true;
var _MessageClassify = require("./MessageClassify");
Object.keys(_MessageClassify).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MessageClassify[key]) return;
  exports[key] = _MessageClassify[key];
});